/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LavoriInsertDTO
 */
export interface LavoriInsertDTO {
    /**
     * 
     * @type {number}
     * @memberof LavoriInsertDTO
     */
    idLavoro?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LavoriInsertDTO
     */
    idPersonale?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof LavoriInsertDTO
     */
    date?: Date;
    /**
     * 
     * @type {number}
     * @memberof LavoriInsertDTO
     */
    idCommessa?: number;
    /**
     * 
     * @type {number}
     * @memberof LavoriInsertDTO
     */
    oreLavorate?: number;
    /**
     * 
     * @type {number}
     * @memberof LavoriInsertDTO
     */
    oreViaggio?: number;
    /**
     * 
     * @type {number}
     * @memberof LavoriInsertDTO
     */
    oreViaggioExtra?: number;
    /**
     * 
     * @type {string}
     * @memberof LavoriInsertDTO
     */
    nota?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LavoriInsertDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LavoriInsertDTO
     */
    idMezzo?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LavoriInsertDTO
     */
    idTipoIntervento?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof LavoriInsertDTO
     */
    smartWorking?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LavoriInsertDTO
     */
    idWBSRamo?: number | null;
}

/**
 * Check if a given object implements the LavoriInsertDTO interface.
 */
export function instanceOfLavoriInsertDTO(value: object): value is LavoriInsertDTO {
    return true;
}

export function LavoriInsertDTOFromJSON(json: any): LavoriInsertDTO {
    return LavoriInsertDTOFromJSONTyped(json, false);
}

export function LavoriInsertDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LavoriInsertDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idLavoro': json['idLavoro'] == null ? undefined : json['idLavoro'],
        'idPersonale': json['idPersonale'] == null ? undefined : json['idPersonale'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'idCommessa': json['idCommessa'] == null ? undefined : json['idCommessa'],
        'oreLavorate': json['oreLavorate'] == null ? undefined : json['oreLavorate'],
        'oreViaggio': json['oreViaggio'] == null ? undefined : json['oreViaggio'],
        'oreViaggioExtra': json['oreViaggioExtra'] == null ? undefined : json['oreViaggioExtra'],
        'nota': json['nota'] == null ? undefined : json['nota'],
        'localita': json['localita'] == null ? undefined : json['localita'],
        'idMezzo': json['idMezzo'] == null ? undefined : json['idMezzo'],
        'idTipoIntervento': json['idTipoIntervento'] == null ? undefined : json['idTipoIntervento'],
        'smartWorking': json['smartWorking'] == null ? undefined : json['smartWorking'],
        'idWBSRamo': json['idWBSRamo'] == null ? undefined : json['idWBSRamo'],
    };
}

export function LavoriInsertDTOToJSON(json: any): LavoriInsertDTO {
    return LavoriInsertDTOToJSONTyped(json, false);
}

export function LavoriInsertDTOToJSONTyped(value?: LavoriInsertDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idLavoro': value['idLavoro'],
        'idPersonale': value['idPersonale'],
        'date': value['date'] == null ? undefined : ((value['date']).toISOString()),
        'idCommessa': value['idCommessa'],
        'oreLavorate': value['oreLavorate'],
        'oreViaggio': value['oreViaggio'],
        'oreViaggioExtra': value['oreViaggioExtra'],
        'nota': value['nota'],
        'localita': value['localita'],
        'idMezzo': value['idMezzo'],
        'idTipoIntervento': value['idTipoIntervento'],
        'smartWorking': value['smartWorking'],
        'idWBSRamo': value['idWBSRamo'],
    };
}

